import { SortParams } from '../../../typings/grid';
import { Marketer } from '../../../typings/marketers';

export const UPDATE_INTERNAL_MARKETERS = 'UPDATE_INTERNAL_MARKETERS';
export type UPDATE_INTERNAL_MARKETERS = typeof UPDATE_INTERNAL_MARKETERS;

export interface UpdateInternalMarketers {
    type: UPDATE_INTERNAL_MARKETERS;
    marketers: Marketer[];
    productsSortParams?: SortParams;
}

export function updateInternalMarketersAction(
    marketers: Marketer[],
    productsSortParams?: SortParams
): UpdateInternalMarketers {
    return {
        type: UPDATE_INTERNAL_MARKETERS,
        marketers,
        productsSortParams
    };
}
